<template>
  <div>
    <div class="edit-box">
      <div class="frm-area">
        <div class="title">基本信息</div>
        <div class="frm-box">
          <van-form @submit="onSubmit">
            <div class="frm-item">
              <div class="frm-label">您的名字</div>
              <van-field
                v-model="frm.nickname"
                placeholder="请填写您的名字"
                :rules="[{ required: true, message: '请填写您的名字' }]"
              />
            </div>
            <div class="frm-item">
              <div class="frm-label">您的手机</div>
              <van-field
                v-model="frm.mobile"
                placeholder="请填写您的手机"
                :rules="[{ required: true, message: '请填写您的手机' }]"
              />
            </div>
            <div class="frm-item">
              <div class="frm-label">登录密码</div>
              <van-field v-model="frm.password" placeholder="新登录密码" />
            </div>
            <div class="frm-item">
              <div class="frm-label">确认密码</div>
              <van-field
                v-model="agepwssword"
                placeholder="再次输入新登录密码"
                :rules="[
                  { validator: validator, message: '两次输入的密码不同' }
                ]"
              />
            </div>
            <div class="btn-box">
              <van-button
                native-type="submit"
                :loading="posting"
                loading-text="提交中..."
                style="
                  background-color: #141423;
                  color: #fff;
                  border-radius: 8px;
                "
                >更新个人信息</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditInfoView',
  data () {
    return {
      posting: false,
      agepwssword: null,
      frm: {
        nickname: null,
        mobile: null,
        password: null,
        
      }
    }
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    validator(val){
      if(this.frm.password){
        return this.frm.password == val
      }
      return true
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'editusr',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
